import { ProductSelectorApi } from '../types/api/product-selector-api';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';

export class SprykerProductsSelectorConfigHandler extends RequestHandler {
  api = {
    target: 'spryker-products-selector-config',
    default: 'spryker-default',
  };

  fetchProductsSelectorConfig(
    url: string,
  ): NetworkResponse<ProductSelectorApi.GetProductSelectorConfigResponse> {
    return this.get<ProductSelectorApi.GetProductSelectorConfigResponse>(
      url,
    );
  }
}

export const SprykerProductsSelectorConfig = new SprykerProductsSelectorConfigHandler();
